import { Autocomplete, Button, Container, Grid, Icon, TextField, Tab, Box } from "@mui/material";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { AdviceDetailsService } from "app/services/advice-details-service";
import { ClientService } from "app/services/client-service";
import { SubwarehouseService } from "app/services/sub-warehouse-service";
import { WarehouseService } from "app/services/warehouse-service";
import React, { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Link, useLocation } from "react-router-dom";


import { OrderService } from "app/services/order-service";
import { Span } from "app/components/Typography";

import { Alert } from 'app/components/Alert';
import { AlertService } from "app/services/alertService"
import OrderLineItem from "../order/order-line-item";
import { useNavigate } from "react-router-dom";
import Loading from 'app/components/MatxLoading';
import { orderTypeService } from "app/services/orderType";
import { OrderDetailsService } from "app/services/order-details-service";

import { PickService } from "app/services/pick-service";
import LoadingModelComponent from "app/components/LoadingModelComponent";
import OrderPickList from "./order-pick-list";
import { PikingOverride } from "./piking-override";
import useAuth from 'app/hooks/useAuth';
const CreateOrder = () => {

    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [orderProcessNumber, setorderProcessNumber] = useState('');
    const [remarks, setremarks] = useState('');
    const [status, setStatus] = useState('New');
    const [OrderMaster, setOrderMaster] = useState({});
    // const [OrderLineItem, setOrderLineItem] = useState([]);
    const [OrderAllocationDetail, setOrderAllocationDetail] = useState([]);
    const [OrderDeatil, setOrderDeatil] = useState([]);
    const [clientNames, setClientNames] = useState([]);
    const [clientId, setClientId] = useState('');
    // const [orderId, setorderId] = useState('');
    const [warehouseNames, setWarehouseNames] = useState([]);
    const [warehouseId, setwarehouseId] = useState('');
    const [subWarehouseNames, setSubWarehouseNames] = useState([]);
    const [ListOrderType, setListOrderType] = useState([]);
    const [SelectedOrderType, setSelectedOrderType] = useState([]);
    const [OrderTypeId, setOrderTypeId] = useState('');
    const [subWarehouseId, setSubWarehouseId] = useState('');
    const [Remarks, setRemarks] = useState('');
    const [file, setFile] = useState({});
    const [OrderMasterCode, setOrderMasterCode] = useState('');
    const [lineItemSubmitted, isLineItemSubmitted] = useState(true);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isLoaded1, setIsLoaded1] = useState(false);
    const [IsEditable, setIsEditable] = useState(false);
    const [ListOrderPick, setListOrderPick] = useState([]);

    const [ListOrderPickOverride, setListOrderPickOverride] = useState([]);
    const { user } = useAuth();
    const location = useLocation();//used to get data from previous page;
    useEffect(() => {

        setOrderMaster(location?.state?.data);
        //setClientId(location?.state?.data?.clientId);
        setClientId(user?.clientId);
        setwarehouseId(location?.state?.data?.warehouseId);
        setSubWarehouseId(location?.state?.data?.subWarehouseId);
        setOrderMasterCode(location?.state?.data?.orderNo);
        setorderProcessNumber(location?.state?.data?.orderProcessNumber);
        setremarks(location?.state?.data?.remarks);
        setOrderTypeId(location?.state?.data?.orderType?.id)

        setStatus(location?.state?.data?.orderStatusTypeDescription)
        if (location?.state?.data?.orderStatusTypeDescription === 'review and accept') {
            setIsEditable(true);
        }
    }, [location?.state?.data]);
    //Advice line item
    useEffect(() => {
        if (OrderMaster?.id) {
            setIsLoaded1(true);
            OrderDetailsService
                .getByOrderId(OrderMaster?.id)
                .then(OrderDet => { if (OrderDet !== null) setOrderDeatil(OrderDet); setIsLoaded1(false); })
                .catch((err) => { console.log(err.message);; setIsLoaded1(false); });
        }
    }, [OrderMaster]);
    useEffect(() => {

        if (OrderMaster?.id && OrderMaster?.orderStatusId === 3) {
            setIsLoaded(true);
            PickService.GetPickingByOrderId(OrderMaster?.id).
                then(res => {
                    setListOrderPick(res); setIsLoaded(false);
                    setListOrderPickOverride(res.filter(s => s.isPickOverride === true));
                }).
                catch((err) => { console.log(err.message); setIsLoaded(false); });
        }
    }, [OrderMaster]);
    //client
    useEffect(() => {
        setIsLoaded(true);
        ClientService
            .getAllClientNames()
            .then(client => {
                if (client !== null) { setClientNames(client); setIsLoaded(false); }
            })
            .catch((err) => { console.log(err.message); setIsLoaded(false); });
    }, []
    );
    const clientChange = (event, value) => {
        if (value)
            setClientId(value.id);
    }
    const OrderTypeChange = (event, value) => {
        if (value)
            setOrderTypeId(value.id);
    }
    //warehouse
    useEffect(() => {
        setIsLoaded(true);
        WarehouseService
            .getAll()
            .then(warehouse => { if (warehouse !== null) { setWarehouseNames(warehouse); setIsLoaded(false) } })
            .catch((err) => { console.log(err.message); setIsLoaded(false) });
    }, []
    );
    useEffect(() => {
        setIsLoaded(true);
        orderTypeService
            .getAll()
            .then(orderType => { if (orderType !== null) { console.log(orderType.filter((item) => item.typeId === 2)); setListOrderType(orderType.filter((t) => t.typeId === 2)); setIsLoaded(false) } })
            .catch((err) => { console.log(err.message); setIsLoaded(false) });
    }, []
    );

    const warehouseChange = (event, value) => {

        if (value) {
            setwarehouseId(value.id);
            setSubWarehouseId('');
            //getSubWarehouses(value?.id);
        }

    }
    useEffect(() => {
        setIsLoaded(true);

        if (warehouseId !== '' && warehouseId !== undefined)
            SubwarehouseService
                .getByWarehouseId(warehouseId)
                .then(subWarehouse => { if (subWarehouse !== null) { setSubWarehouseNames(subWarehouse); setIsLoaded(false); } })
                .catch((err) => { console.log(err.message); setIsLoaded(false); });
    }, [warehouseId]
    );

    const populateWarehouseData = () => {
        const warehouseData = warehouseNames.find(item => (item.id === warehouseId)) || {}
        if (warehouseId && subWarehouseNames?.length === 0) {
            //getSubWarehouses(warehouseId);
        }
        return warehouseData;
    }

    //sub warehouse
    const subWarehouseChange = (event, value) => {
        if (value)
            setSubWarehouseId(value.id)
    }
    const populateSubWarehouseData = () => {
        const subWarehouseData = subWarehouseNames?.find(item => (item.id === subWarehouseId)) || {}
        return subWarehouseData;
    }
    //File
    const handleFileUpload = (e) => {
        if (!e.target.files) {
            return;
        }
        const file = e.target.files[0];
        setFile(file);
    };
    const clearFileTarget = (e) => {
        e.target.value = ''
    }
    const clearFile = (e) => {
        setFile({});
    }
    const handlePONumberChange = (event) => {
        setorderProcessNumber(event.target.value)
    }
    const handleRemarksChange = (event) => {
        setremarks(event.target.value)
    }
    const navigate = useNavigate();
    const handleSubmit = () => {

        OrderService.updateOrderStatusAllocated(OrderMaster?.id).then(resp => { navigate("/outward/order/list"); }).catch((err) => { AlertService.error(err.message, { keepAfterRouteChange: true }); console.log(err.message); setIsLoaded(false) });
    };

    const createFormData = () => {

        let formData = new FormData();
        formData.append("file", file);
        formData.append("clientId", clientId || OrderMaster?.customerId);
        formData.append("subWarehouseId", subWarehouseId);
        formData.append("warehouseId", warehouseId);
        formData.append("purchaseOrderNumber", orderProcessNumber || OrderMaster?.orderProcessNumber);
        formData.append("id", OrderMaster?.id || '');
        formData.append("orderTypeId", OrderTypeId);
        formData.append("remarks", remarks);
        return formData;
    }

    const uploadCsvFiles = () => {


        var isValidated = true;
        if (file.name === undefined) {
            AlertService.error('Please Select Inward Template', { keepAfterRouteChange: true });
            isValidated = false;
        }
        if (clientId === '' || clientId === undefined) {
            AlertService.error('Please Select Customer ', { keepAfterRouteChange: true });
            isValidated = false;
        }
        if (subWarehouseId === '' || subWarehouseId === undefined) {
            AlertService.error('Please Select Subwarehouse ', { keepAfterRouteChange: true });
            isValidated = false;
        }
        if (OrderTypeId === '' || OrderTypeId === undefined) {
            AlertService.error('Please Select Order Type ', { keepAfterRouteChange: true });
            isValidated = false;
        }
        if (remarks === '' || remarks === undefined) {
            AlertService.error('Please enter remarks ', { keepAfterRouteChange: true });
            isValidated = false;
        }
        if (isValidated) {
            if (OrderMaster?.id) {
                createOrder();
            } else {
                createOrder();
            }
        }


    }
    const createOrder = () => {
        setIsLoaded(true);
        OrderService
            .createFormData(createFormData())
            .then(response => {
                if (response !== null) {
                    isLineItemSubmitted(false);
                    //setorderId(response.order.id)
                    setOrderDeatil(response?.order.orderDetails);
                    setOrderMaster(response?.order)
                    //setOrderProcessNo(response?.OrderProcessNo);
                    setStatus(response?.order.orderStatusId);
                    setIsLoaded(false);
                }
            })
            .catch((err) => { console.log(err.message); setIsLoaded(false); });

    }
    const updateAdvice = (formData) => {
        setIsLoaded(true);
        OrderService.updateFormData(createFormData(), OrderMaster?.id)
            .then(response => {
                if (response !== null) {
                    isLineItemSubmitted(false);
                    setOrderDeatil(response?.order.orderDetails);
                    //setOrderProcessNo(response?.order.OrderProcessNo);
                    setStatus(response?.order.orderStatusId);
                    setIsLoaded(false);
                }
            })
            .catch((err) => {
                setIsLoaded(false);
                console.log(err.message);
            });
    }
    const MenuhandleCallback = (childData) => {

        setIsLoaded(childData)
        AlertService.error(childData);
    }

    return (
        <div>

            <Grid margin={1}>
                <LoadingModelComponent isLoading={isLoaded} />
                <LoadingModelComponent isLoading={isLoaded1} />
                <Alert />
                <Link color="primary" variant="contained" to={{ pathname: '/outward/order/list', state: {} }} >Back to List of Outward</Link>
                <ValidatorForm onSubmit={handleSubmit} onError={() => null} >
                    <Grid container spacing={1} sx={{ mt: 2 }}>
                        <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                            <Autocomplete
                                size="small"
                                value={clientNames?.find(item => (item.id === OrderMaster?.customerId || item.id === clientId)) || {}}
                                options={clientNames || {}}
                                disabled={true}
                                onChange={clientChange}
                                getOptionLabel={(option) => option.clientName || ''}
                                renderInput={(params) => (
                                    <TextField {...params} label="Client Name" variant="outlined" fullWidth />
                                )}
                            />
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                            <Autocomplete
                                size="small"
                                value={ListOrderType?.find(item => (item.id === OrderMaster?.orderTypeId || item.id === OrderTypeId)) || {}}
                                options={ListOrderType || {}}
                                disabled={IsEditable}
                                onChange={OrderTypeChange}
                                getOptionLabel={(option) => option.description || ''}
                                renderInput={(params) => (
                                    <TextField {...params} label="Order Type " variant="outlined" fullWidth />
                                )}
                            />
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                            <Autocomplete
                                size="small"
                                value={populateWarehouseData() || {}}
                                options={warehouseNames || {}}
                                disabled={IsEditable}
                                onChange={warehouseChange}
                                getOptionLabel={(option) => option.warehouseName || ''}
                                renderInput={(params) => (
                                    <TextField {...params} label="Warehouse code" variant="outlined" fullWidth />
                                )}
                            />
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                            <Autocomplete
                                size="small"
                                options={subWarehouseNames}
                                disabled={IsEditable || warehouseNames.length === 0}
                                value={populateSubWarehouseData()}
                                onChange={subWarehouseChange}
                                getOptionLabel={(option) => option.subCode || ''}
                                renderInput={(params) => (
                                    <TextField {...params} label="Sub Warehouse code" variant="outlined" fullWidth />
                                )}
                            />
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                            <TextField
                                style={{ display: 'flex' }}
                                type="text"
                                size="small"
                                name="username"
                                disabled
                                id="standard-basic"
                                value={OrderMasterCode || ''}
                                label="Code"
                            />
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                            <TextField
                                style={{ display: 'flex' }}
                                type="text"
                                size="small"
                                name="orderProcessNumber"
                                id="standard-basic"
                                disabled={IsEditable || subWarehouseNames.length === 0}
                                value={orderProcessNumber || ''}
                                onChange={handlePONumberChange}
                                label="Order Process No"
                            />
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                            <TextField
                                style={{ display: 'flex' }}
                                type="text"
                                size="small"
                                disabled
                                id="standard-basic"
                                value={status}
                                label="Status"
                                validators={["required", "minStringLength: 1", "maxStringLength: 32"]}
                            />
                        </Grid>
                        <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                            <TextField
                                style={{ display: 'flex' }}
                                type="text"
                                size="small"
                                disabled={IsEditable}
                                id="standard-basic"
                                onChange={handleRemarksChange}
                                value={remarks}
                                label="remarks"
                                validators={["required", "minStringLength: 1", "maxStringLength: 32"]}
                            />
                        </Grid>
                        {!IsEditable ? <Grid container margin={1} >
                            <Grid item lg={3} md={3} sm={6} xs={6} sx={{ mt: 2 }}>
                                <Button
                                    component="label"
                                    size="small"
                                    style={{ display: 'flex', height: '100%' }}
                                    disabled={IsEditable || subWarehouseNames.length === 0}
                                    variant="outlined"> {file.name || 'Select Order Item CSV'}
                                    <input type="file" accept=".csv" hidden onChange={handleFileUpload} onClick={clearFileTarget} />
                                    <Button style={{ margin: '0 0 0 5px' }} onClick={clearFile}><Icon>clear</Icon></Button>
                                </Button>
                            </Grid>
                            <Grid item lg={2} md={2} sm={6} xs={6} sx={{ mt: 2 }}>
                                <Button
                                    size="small"
                                    component="label"
                                    disabled={IsEditable || subWarehouseNames.length === 0 || clientId === ''}
                                    onClick={uploadCsvFiles}
                                    style={{ display: 'flex', height: '100%' }}
                                    variant="outlined"> UPLOAD<Icon>upload</Icon>
                                </Button>
                            </Grid>
                        </Grid>
                            : null}



                    </Grid>

                </ValidatorForm>
                <Grid >
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab label="Order Line Detail" value="1" />
                                    {/* {IsEditable ? <Tab label="Order Pick List" value="2" /> : null}
                                    {ListOrderPickOverride.length > 0 ? <Tab label="Override Pick List" value="3" /> : null} */}

                                </TabList>
                            </Box>
                            <TabPanel value="1">

                                {OrderDeatil.length > 0 ? <OrderLineItem data={OrderDeatil}></OrderLineItem> : null}
                                {!lineItemSubmitted || status === 'created' ? <Grid container spacing={2} sx={{ mb: 3 }}>
                                    <Grid item lg={10} md={10} sm={12} xs={12} sx={{ mt: 1 }}></Grid>
                                    <Grid item lg={2} md={2} sm={6} xs={6} sx={{ mt: 1 }}>
                                        <Button
                                            color="primary"
                                            height="100%"
                                            variant="contained"
                                            onClick={handleSubmit}
                                            type="submit">
                                            <Icon>send</Icon>
                                            <Span sx={{ pl: 1, textTransform: "capitalize" }}>Submit</Span>
                                        </Button>
                                    </Grid>
                                </Grid> : null}

                            </TabPanel>
                            {/* {ListOrderPick.length > 0 ?
                                <TabPanel value="2">
                                    <OrderPickList data={ListOrderPick} />
                                </TabPanel>
                                : null}
                            {ListOrderPickOverride.length > 0 ?
                                <TabPanel value="3">
                                    <PikingOverride data={ListOrderPickOverride} />
                                </TabPanel>
                                : null} */}
                        </TabContext>
                    </Box>

                </Grid>
            </Grid>



        </div >
    );
}
export default CreateOrder;